import { useEffect, useState } from 'react'

import { useFetchAndLoad } from 'hooks'
import { checkEmailValidation } from 'services/auth.service'

export default function useEmailValidation(email: string) {
  const { callEndpoint } = useFetchAndLoad()
  const [isValidated, setIsValidated] = useState(false)
  const [checking, setChecking] = useState(false)

  const checkValidation = async () => {
    if (checking || !email) return

    try {
      setChecking(true)
      const response = await callEndpoint(checkEmailValidation(email))

      if (response.data?.email_validated === true) {
        setIsValidated(true)
        return true
      }
      return false
    } catch (error) {
      console.error('Error checking email validation:', error)
      return false
    } finally {
      setChecking(false)
    }
  }

  useEffect(() => {
    if (!email) {
      return
    }

    checkValidation()

    const handleFocus = () => {
      checkValidation()
    }

    window.addEventListener('focus', handleFocus)

    const interval = setInterval(() => {
      checkValidation()
    }, 5000)

    return () => {
      window.removeEventListener('focus', handleFocus)
      clearInterval(interval)
    }
  }, [email])

  return {
    isValidated,
    checking,
    checkValidation,
  }
}
